<template>
  <div>
    <div class="page_title">
      雇员详情
    </div>
    <div class="table_container">
      <div class="table">
        <div class="label_grounp">
          <div class="label_row">
            <div class="label_cell">openId</div>
            <div class="value_cell">{{employee.userAccount}}</div>
          </div>
          <div class="label_row">
            <div class="label_cell">姓名</div>
            <div class="value_cell">{{employee.name}}</div>
          </div>
          <div class="label_row">
            <div class="label_cell">手机</div>
            <div class="value_cell">{{employee.phone}}</div>
          </div>
          <div class="label_row">
            <div class="label_cell">申请时间</div>
            <div class="value_cell">{{employee.createTime}}</div>
          </div>
          <div class="label_row">
            <div class="label_cell">状态</div>
            <div class="value_cell" v-if="employee.applyState == -1">驳回</div>
            <div class="value_cell" v-else-if="employee.applyState == 0">申请中</div>
            <div class="value_cell" v-else-if="employee.applyState == 1">成功</div>
          </div>
        </div>
      </div>
      <div class="button_grounp" v-if="employee.applyState == 0">
        <button class="button refuse" @click="approve('-1')">拒绝</button>
        <button class="button approve" @click="approve('1')">通过</button>
      </div>
    </div>
  </div>
</template>

<script>
import {approveStaffApply} from "../api";
export default {
  name: "employee_detail",
  data(){
    return{
      employee: {
        name: '',
        userAccount: '',
        phone: '',
        state: '',
        createTime: '',
        id: '',
      }
    }
  },
  mounted() {
    console.log('雇员', this.$route.params.person);
    this.employee = this.$route.params.person;
  },
  methods:{
    // 通过
    approve(opinion){
      approveStaffApply(this.employee.id,opinion).then(res => {
        console.log('雇员申请批准', res);
        if(res.data.retcode == 0){
          alert('审批成功');
          this.$router.go(-1)
        }else{
          alert(`${res.data.retmsg}`)
        }
      })
    }
  }
}
</script>

<style src="../css/employee_detail.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/employee_detail.vue